"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("react-icons");
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const icon_list_1 = require("./icon_list");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const Icon = ({ name, color, size = base_ui_theme_spacing_1.space.medium }) => {
    // Transform size number into pixel string
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = (theme || base_ui_theme_themes_1.unboaredTheme.default);
    const icolor = color || currentTheme.textColor;
    const realSize = `${normalize(size)}px`;
    const IconName = icon_list_1.iconMap[name] || icon_list_1.iconMap.error;
    return (react_1.default.createElement(react_icons_1.IconContext.Provider, { value: { color: icolor, size: realSize, style: { verticalAlign: 'middle' } } },
        react_1.default.createElement(IconName, null)));
};
exports.Icon = Icon;
//# sourceMappingURL=icon.js.map